import { createSelector } from '@reduxjs/toolkit';

import { getImmutableCompatible } from 'src/utils/immutableUtils';
import { MODULE_NAME } from 'src/constants';
import { getAppName, getIsWhitelabel } from '../view/selectors';
import { name } from './slice';

import type { IHeaderBanner } from './types';

const getHeaderBanner = (state): IHeaderBanner | undefined =>
  getImmutableCompatible(state, name);

export const getHeaderBannerData = createSelector(
  [getHeaderBanner],
  (headerBanner) => headerBanner?.bannerData,
);

export const getIsHeaderBannerAvailable = createSelector(
  [getHeaderBanner, getAppName, getIsWhitelabel],
  (headerBanner, appName, isWL) =>
    (appName !== MODULE_NAME.HOME && !isWL) || headerBanner?.isAvailable,
);

export const getIsHeaderBannerHidden = createSelector(
  [getHeaderBanner],
  (headerBanner) => headerBanner?.isHidden,
);
